export default "__VITE_ASSET__CRiz0T5j__"